(function (root, factory) {
  const api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.BakerraePiePickup = api;
})(typeof window !== 'undefined' ? window : undefined, function (root) {
  const PRODUCT_ID = '15945515467038';
  const VARIANT_IDS = ['60150240936222', '60150240968990'];
  const TIMEZONE = 'America/Toronto';
  const LOCATION = '326 Broadview Ave';
  // Toronto is UTC-4 on all three dates. Expiry is the end of the pickup window.
  const WINDOWS = Object.freeze({
    '2026-10-10': { label: '12:00 PM – 5:00 PM', end: '2026-10-10T21:00:00Z' },
    '2026-10-11': { label: '12:00 PM – 5:00 PM', end: '2026-10-11T21:00:00Z' },
    '2026-10-12': { label: '10:00 AM – 12:00 PM', end: '2026-10-12T16:00:00Z' },
  });
  const CART_ERROR = 'Choose and save pickup details for every Thanksgiving pie in the cart before checkout. You can also remove the pie and add it again from its product page.';
  let cartPresent = Boolean(root && root.document && root.document.documentElement.dataset.pieCartPresent === 'true');
  let cartReady = false;
  let cartChecking = true;
  let refreshGeneration = 0;

  function property(properties, name) {
    if (Array.isArray(properties)) return (properties.find((entry) => entry && entry[0] === name) || [])[1] || '';
    return (properties && properties[name]) || '';
  }
  function isPieItem(item) { return String(item.product_id) === PRODUCT_ID; }
  function selectionProperties(date, window) {
    return { 'Pickup Date': date, 'Pickup Window': window, 'Pickup Timezone': TIMEZONE, 'Pickup Location': LOCATION };
  }
  function validSelection(properties, now = Date.now()) {
    const date = property(properties, 'Pickup Date');
    const window = WINDOWS[date];
    return Boolean(window && Number.isFinite(now) && now < Date.parse(window.end) &&
      property(properties, 'Pickup Window') === window.label &&
      property(properties, 'Pickup Timezone') === TIMEZONE && property(properties, 'Pickup Location') === LOCATION);
  }
  function validateCart(cart, now = Date.now()) {
    if (!cart || !Array.isArray(cart.items)) return { ok: false, message: 'Pickup details could not be validated. Refresh the cart and try again.' };
    const invalidItem = cart.items.find((item) => isPieItem(item) && !validSelection(item.properties, now));
    return invalidItem ? { ok: false, message: CART_ERROR, itemKey: invalidItem.key } : { ok: true };
  }
  function fetchCart() {
    return root.fetch(`${(root.routes && root.routes.cart_url) || '/cart'}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((response) => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then((cart) => { if (!Array.isArray(cart.items)) throw new Error('Cart unavailable'); return cart; });
  }
  function hasUnsavedCartSelection() {
    return Boolean(root && root.document && Array.from(root.document.querySelectorAll('thanksgiving-pie-pickup[data-line-key]'))
      .some((picker) => typeof picker.isDirty === 'function' && picker.isDirty()));
  }
  function updateControls() {
    root.document.documentElement.dataset.pieCartPresent = String(cartPresent);
    root.document.documentElement.dataset.pieCartChecking = String(cartChecking);
    const unsaved = hasUnsavedCartSelection();
    root.document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach((button) => {
      if (cartChecking || cartPresent || button.hasAttribute('data-pie-checkout')) {
        if (!button.hasAttribute('data-pie-managed')) {
          button.dataset.pieOriginalDisabled = String(button.disabled && !button.hasAttribute('data-pie-checkout'));
          button.dataset.pieManaged = 'true';
        }
        button.disabled = cartChecking || !cartReady || unsaved;
      } else if (button.hasAttribute('data-pie-managed')) {
        button.disabled = button.dataset.pieOriginalDisabled === 'true';
        delete button.dataset.pieManaged;
      }
    });
  }
  function applyCart(cart) {
    const result = validateCart(cart);
    cartChecking = false;
    cartPresent = cart.items.some(isPieItem);
    cartReady = result.ok && cart.items.length > 0;
    updateControls();
    root.document.querySelectorAll('[data-pie-checkout-error]').forEach((element) => {
      element.hidden = result.ok;
      if (!result.ok) element.textContent = result.message;
    });
    return result;
  }
  function refreshCart() {
    const generation = ++refreshGeneration;
    cartReady = false;
    cartChecking = true;
    if (root.document.querySelector('[data-pie-cart-summary]:not([data-pie-count="0"])')) cartPresent = true;
    updateControls();
    return fetchCart().then((cart) => {
      if (generation === refreshGeneration) applyCart(cart);
      return cart;
    }).catch(() => {
      if (generation === refreshGeneration) { cartReady = false; updateControls(); }
    });
  }
  function validateForm(form) {
    const picker = form.querySelector('thanksgiving-pie-pickup:not([data-line-key])');
    const variant = form.querySelector('[name="id"]');
    if (!picker && (!variant || !VARIANT_IDS.includes(String(variant.value)))) return true;
    return Boolean(picker && typeof picker.validate === 'function' && picker.validate());
  }

  if (root && root.HTMLElement) {
    class ThanksgivingPiePickup extends root.HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.date = this.querySelector('[data-pie-date]');
        this.window = this.querySelector('[data-pie-window]');
        this.message = this.querySelector('[data-pie-message]');
        this.form = this.closest('form');
        this.button = this.querySelector('[data-pie-save]') || (this.form && this.form.querySelector('[name="add"]'));
        this.stockAvailable = this.dataset.stockAvailable === 'true';
        this.date.value = this.dataset.currentDate || this.date.value;
        this.populateWindows(this.dataset.currentWindow || this.window.value);
        this.addEventListener('change', (event) => {
          // CartItems change handlers expect quantity inputs only.
          if (this.dataset.lineKey) event.stopPropagation();
          if (event.target === this.date) this.populateWindows();
          this.validate();
        });
        this.querySelector('[data-pie-save]')?.addEventListener('click', () => this.save());
        if (!this.dataset.lineKey && typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== (this.closest('product-info')?.dataset.originalSection || this.closest('product-info')?.dataset.section)) return;
            const variant = event.data.variant;
            const source = event.data.html.querySelector('thanksgiving-pie-pickup');
            this.stockAvailable = Boolean(variant && variant.available && source && source.dataset.stockAvailable === 'true');
            this.validate();
          });
        }
        this.validate();
      }
      disconnectedCallback() { if (this.unsubscribe) this.unsubscribe(); this.initialized = false; }
      populateWindows(previous = '') {
        this.window.replaceChildren(new root.Option(this.dataset.selectWindow, ''));
        const window = WINDOWS[this.date.value];
        const available = window && Date.now() < Date.parse(window.end);
        if (available) this.window.add(new root.Option(window.label, window.label));
        this.window.disabled = !available;
        this.window.value = available && previous === window.label ? previous : '';
        Array.from(this.date.options).forEach((option) => {
          if (WINDOWS[option.value]) option.disabled = Date.now() >= Date.parse(WINDOWS[option.value].end);
        });
      }
      isDirty() {
        return Boolean(this.dataset.lineKey && (this.date.value !== (this.dataset.currentDate || '') ||
          this.window.value !== (this.dataset.currentWindow || '')));
      }
      validate() {
        const validVariant = Boolean(this.dataset.lineKey || VARIANT_IDS.includes(String(this.form?.querySelector('[name="id"]')?.value)));
        const valid = this.stockAvailable && validVariant && validSelection(selectionProperties(this.date.value, this.window.value));
        this.message.textContent = valid ? (this.isDirty() ? this.dataset.dirtyMessage : '') : (WINDOWS[this.date.value] && Date.now() >= Date.parse(WINDOWS[this.date.value].end)
          ? this.dataset.expiredMessage : this.dataset.requiredMessage);
        if (this.button) {
          this.button.disabled = !valid || Boolean(this.saving);
          if (!this.dataset.lineKey && this.stockAvailable) {
            this.button.querySelector('span').textContent = root.variantStrings.addToCart;
          }
        }
        if (this.dataset.lineKey) updateControls();
        return valid;
      }
      async save() {
        if (this.saving || !this.validate()) return;
        this.saving = true;
        this.validate();
        this.message.textContent = this.dataset.saving;
        cartReady = false;
        updateControls();
        try {
          const cart = await fetchCart();
          const item = cart.items.find((line) => line.key === this.dataset.lineKey && isPieItem(line));
          if (!item) throw new Error('Line changed');
          const properties = { ...item.properties, ...selectionProperties(this.date.value, this.window.value) };
          // Recheck immediately before writing in case the window expired during the fetch.
          if (!validSelection(properties)) throw new Error('Window expired');
          const response = await root.fetch((root.routes && root.routes.cart_change_url) || '/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
          });
          if (!response.ok) throw new Error('Save failed');
          const updatedCart = await response.json();
          const savedLine = updatedCart.items?.find((line) => isPieItem(line) && String(line.variant_id) === String(item.variant_id) &&
            line.quantity >= item.quantity && Object.keys(properties).every((key) => property(line.properties, key) === properties[key]));
          if (!savedLine) throw new Error('Save failed');
          // Reload the cart so changed line keys, quantities and all line-property displays stay in sync.
          root.location.assign((root.routes && root.routes.cart_url) || '/cart');
        } catch (error) {
          this.saving = false;
          this.validate();
          this.message.textContent = this.dataset.saveError;
          refreshCart();
        }
      }
    }
    if (!root.customElements.get('thanksgiving-pie-pickup')) root.customElements.define('thanksgiving-pie-pickup', ThanksgivingPiePickup);
  }
  if (root && root.document) {
    root.document.addEventListener('submit', (event) => {
      if (!validateForm(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.target.querySelector('[data-pie-date]')?.focus();
      } else if (event.target.querySelector('thanksgiving-pie-pickup:not([data-line-key])')) {
        cartPresent = true;
        cartChecking = true;
        cartReady = false;
        updateControls();
      }
    }, true);
    root.addEventListener('pageshow', () => {
      root.document.querySelectorAll('thanksgiving-pie-pickup').forEach((picker) => picker.validate());
      refreshCart();
    });
    root.addEventListener('focus', refreshCart);
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
    // Newly rendered drawer/page controls stay disabled until a fresh cart is validated.
    const observer = new root.MutationObserver((records) => {
      const changed = records.some((record) => Array.from(record.addedNodes).some((node) => node.nodeType === 1 &&
        (node.matches('[data-pie-cart-summary], [name="checkout"]') || node.querySelector('[data-pie-cart-summary], [name="checkout"]'))));
      if (changed) refreshCart();
    });
    observer.observe(root.document.documentElement, { childList: true, subtree: true });
    refreshCart();
  }
  return { PRODUCT_ID, WINDOWS, TIMEZONE, LOCATION, isPieItem, property, selectionProperties, validSelection, validateCart, validateForm, refreshCart, applyCart, hasUnsavedCartSelection };
});
